import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@modules/auth/auth.service';
import { Location } from '@angular/common';
@Injectable({
    providedIn: 'root'
})
export class LoginAccessGuard  {
    constructor(
        private router: Router,
        private authService: AuthService,
        private location: Location
    ) {
    }

    canActivate() {
        if (this.authService.isLoggedIn) {
            return true;
        } else {
            const currentUrl = this.location.path(true);
            return this.router.navigate(['/auth/login'], {
                queryParams: { redirectUrl: currentUrl }
            });
        }
    }
}
